import { useEffect, useRef } from "react";

import { debounce } from "lodash-es";

import { CM_CREATE_EVENT } from "src/base-components/CodeInput/useOnCreateEvent";

export const useCodeMirrorEventListener = (callbackArg: VoidFunction) => {
  const callbackRef = useRef(callbackArg);

  useEffect(() => {
    callbackRef.current = callbackArg;
  }, [callbackArg]);

  useEffect(() => {
    const callback = debounce(() => {
      callbackRef.current();
    }, 100);

    document.addEventListener(CM_CREATE_EVENT, callback);

    return () => {
      document.removeEventListener(CM_CREATE_EVENT, callback);
    };
  }, []);
};
